const Company = resolve => require.ensure([], () => resolve(require('@/views/company/company.vue')), 'Company')

const List = resolve => require.ensure([], () => resolve(require('@/views/company/list/list.vue')), 'List')

const Detail = resolve => require.ensure([], () => resolve(require('@/views/company/detail/detail.vue')), 'Detail')

const collectDetail = resolve => require.ensure([], () => resolve(require('@/views/company/detail/collectDetail.vue')), 'collectDetail')

const collectList = resolve => require.ensure([], () => resolve(require('@/views/company/list/collectList.vue')), 'collectList')
export default [
    {
        path: '/company',
        name: 'company',
        component: Company,
        redirect: {
            name: 'company-list'
        },
        children: [
            {
                path: 'list',
                name: 'company-list',
                component: List,
                meta: {
                    title: '物流公司列表',
                    icons: 'fa fa-company',
                    isWXShare:true
                }
            },{
                path: 'collectList',
                name: 'callect-company-list',
                component: collectList,
                meta: {
                    title: '收藏列表',
                    icons: 'fa fa-company',
                    isWXShare:true,
                    requireAuth: true
                }
            }, {
                path: 'detail',
                component: Detail,
                name: 'company-detail',
                meta: {
                    title: '物流公司详情',
                    icons: 'fa fa-detail'
                }
            }, {
                path: 'collectDetail',
                component: collectDetail,
                name: 'collect-company-detail',
                meta: {
                    title: '物流公司详情',
                    icons: 'fa fa-detail'
                }
            }
        ]

    }
]